import { Middleware } from '@nuxt/types';
import { baseTestName } from '~/constants/aBTestName';

const abTestMiddleware: Middleware = ({ app, store, route }) => {
  if (route.path === '/') {
    const cookieName = 'ab_test';
    let testName = app.$cookies.get(cookieName);
    if (!testName || route.query.abBranch) {
      if (route.query.abBranch) {
        testName = `${baseTestName}__${route.query.abBranch}`;
      } else {
        testName = `${baseTestName}__${Math.random() > 0.5 ? 'a' : 'b'}`;
      }
      app.$cookies.set(cookieName, testName, { maxAge: 60 * 60 * 24 * 60 }); // 60 days
    }
    store.commit('setAbTest', testName);
  }
};

export default abTestMiddleware;
